const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.627.067H7.775a1.6,1.6,0,0,0-1.6,1.6V38.338a1.6,1.6,0,0,0,1.6,1.595h24.45a1.6,1.6,0,0,0,1.595-1.595V8.26Z",
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.627 8.26 33.82 8.26 25.627 0.067 25.627 8.26",
    style: {
      fill: "#dbddde"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.647,29.839H5.353A1.063,1.063,0,0,1,4.29,28.776V19.417a1.063,1.063,0,0,1,1.063-1.063H34.647a1.063,1.063,0,0,1,1.063,1.063v9.359A1.063,1.063,0,0,1,34.647,29.839Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.035,21.781a1.856,1.856,0,0,1,.586,1.509,1.79,1.79,0,0,1-.6,1.493,2.928,2.928,0,0,1-1.833.473h-1V26.9h-.947V21.291h1.926A2.881,2.881,0,0,1,16.035,21.781Zm-.67,2.316a1.241,1.241,0,0,0,.284-.884.913.913,0,0,0-.361-.822,2.078,2.078,0,0,0-1.132-.241h-.963V24.4h1.1A1.472,1.472,0,0,0,15.365,24.1Z",
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.983,22.025a2.615,2.615,0,0,1,.81,2.043,2.75,2.75,0,0,1-.786,2.071A3.343,3.343,0,0,1,19.6,26.9H17.736V21.291h1.927A3.343,3.343,0,0,1,21.983,22.025Zm-.145,2.067q0-1.926-2.207-1.926h-.947v3.845h1.052a2.265,2.265,0,0,0,1.561-.486A1.824,1.824,0,0,0,21.838,24.092Z",
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.961,22.174v1.541h2.488v.875H24.961V26.9h-.947V21.291h3.74l-.008.883Z",
    style: {
      fill: "#f5f6f7"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file_pdf.50b60eec048ece0826e4f0ae30c87ea2.svg";
export { ForwardRef as ReactComponent };